export default __webpack_public_path__ + "static/media/how1.3ae2fe95.jpg";